// 261029 P1 B2(d) — khoá nạp lại `locations/:id/views` của thẻ bối cảnh. Trước: khoá = JSON(phase, views của ctx) đổi ngay khi ctx hydrate lần đầu (views [] → danh sách thật, IDLE→IDLE)
// ⇒ thẻ nạp `locations/:id/views` LẦN HAI chỉ vì dữ liệu hạt giống về.
// Vòng 3 (sửa sau review F1): bỏ lượt nạp thừa CHỈ KHI bản ctx hydrate đầu tiên TƯƠNG ĐƯƠNG với bản thẻ ĐÃ nạp thật (cùng id · status · imageUrl của các view hướng-plan mà ctx thấy).
// Khác phiên bản (thẻ cũ, ctx mới — hoặc ngược lại) ⇒ khoá đổi ngay ⇒ thẻ nạp lại. Thẻ chưa báo bản đã nạp ⇒ chờ (giữ 'initial'), không đoán.
// THUẦN (không React/antd) ⇒ test được dưới jest; caller giữ `memo` trong useRef.
export interface ViewsRefreshMemo { state: 'pending' | 'baseline' | 'diverged'; baseline: string | null }
export const newViewsRefreshMemo = (): ViewsRefreshMemo => ({ state: 'pending', baseline: null });

export interface ViewLite { id: string; status?: string | null; imageUrl?: string | null }
const row = (v: ViewLite) => [v.id, v.status ?? null, v.imageUrl ?? null];
const byId = (a: ViewLite, b: ViewLite) => (a.id < b.id ? -1 : a.id > b.id ? 1 : 0);

/** Bản chụp (id, status, imageUrl) của các view mà ctx thấy, theo id. */
export const ctxViewsProjection = (ctxViews: ViewLite[]): string => JSON.stringify([...ctxViews].sort(byId).map(row));
/**
 * Cùng bản chụp nhưng lấy từ views THẺ ĐÃ NẠP, chỉ trên các id ctx thấy (thẻ còn có view mặc định / plan khác mà ctx không trả).
 * `null` = thẻ chưa nạp xong (chưa so được). Thẻ thiếu một id mà ctx có ⇒ chuỗi khác cố ý (không tương đương).
 */
export function cardViewsProjection(cardViews: ViewLite[] | null, ctxViews: ViewLite[]): string | null {
  if (cardViews === null) return null;
  const byKey = new Map(cardViews.map((v) => [v.id, v]));
  const picked: ViewLite[] = [];
  for (const c of ctxViews) {
    const v = byKey.get(c.id);
    if (!v) return JSON.stringify({ missing: c.id });
    picked.push(v);
  }
  return ctxViewsProjection(picked);
}

export interface ViewsRefreshInput {
  /** ctx chưa hydrate xong. */
  loading: boolean;
  /** JSON(phase, views[id, status, imageUrl]) hiện tại của ctx. */
  raw: string;
  /** `ctxViewsProjection(ctx.views)`. */
  ctxProjection: string;
  /** `cardViewsProjection(cardViews, ctx.views)`; null = thẻ chưa nạp xong. */
  cardProjection: string | null;
}

export function resolveViewsRefreshKey(memo: ViewsRefreshMemo, input: ViewsRefreshInput): string {
  if (input.loading) { memo.state = 'pending'; memo.baseline = null; return 'initial'; }
  if (memo.state === 'pending') {
    if (input.cardProjection === null) return 'initial';        // thẻ chưa báo bản đã nạp: chưa so được, không đoán
    if (input.cardProjection === input.ctxProjection) { memo.state = 'baseline'; memo.baseline = input.raw; }
    else memo.state = 'diverged';                                 // hai nguồn thấy hai phiên bản ⇒ nạp lại thẻ
  }
  if (memo.state === 'baseline') return input.raw === memo.baseline ? 'initial' : input.raw;
  return input.raw;
}
